import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Zap } from 'lucide-react';
import { AutoScrollImages } from '../AutoScrollImages';
import { RatingBadge } from '../RatingBadge';

const FALLBACK = ['https://images.unsplash.com/photo-1561501900-3701fa6a0864?w=800'];

/**
 * Compact featured hotel card used in HomePage Top Hotels section.
 */
export const TopHotelCard = ({ hotel, detailsUrl, hasDates }) => {
  const navigate = useNavigate();
  const href = detailsUrl || `/hotels/${hotel._id}`;
  const minPrice = hotel.min_price || 0;
  const imgs = hotel.images && hotel.images.length > 0 ? hotel.images : FALLBACK;

  const handleQuickBook = (e) => {
    e.stopPropagation();
    navigate(`${href}${href.includes('?') ? '&' : '?'}quick=1`);
  };

  return (
    <div
      onClick={() => navigate(href)}
      className="group cursor-pointer relative"
      data-testid={`top-hotel-${hotel._id}`}
    >
      <div className="relative aspect-[4/3] rounded-xl overflow-hidden mb-3 bg-gray-100">
        <AutoScrollImages images={imgs} alt={hotel.hotel_name} interval={3200} className="group-hover:scale-105 transition-transform duration-500" />
        {hotel.commission_rate > 25 && (
          <div className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-white/95 backdrop-blur text-[10px] font-black text-black uppercase tracking-wide z-10">
            ⭐ Featured
          </div>
        )}
        {hasDates && (
          <button
            onClick={handleQuickBook}
            className="absolute bottom-3 right-3 px-3 py-1.5 rounded-full bg-[#FF0059] hover:bg-[#CC0047] text-white text-[11px] font-black flex items-center gap-1 shadow-lg z-10 transition-colors"
            data-testid={`quick-book-${hotel._id}`}
          >
            <Zap className="h-3 w-3 fill-current" /> Quick Book
          </button>
        )}
      </div>
      <h3 className="font-bold text-base leading-tight text-black group-hover:underline line-clamp-1">{hotel.hotel_name}</h3>
      <p className="text-xs text-gray-500 mt-0.5 line-clamp-1 flex items-center gap-1">
        <MapPin className="h-3 w-3" /> {hotel.city_area}
      </p>
      {hotel.rating > 0 && (
        <div className="mt-1.5">
          <RatingBadge value={hotel.rating} count={hotel.rating_count} size="sm" testId={`top-rating-${hotel._id}`} />
        </div>
      )}
      <div className="mt-2 flex items-baseline gap-1">
        <span className="text-lg font-black text-black">₹{minPrice.toLocaleString('en-IN')}</span>
        <span className="text-xs text-gray-500">/night</span>
      </div>
    </div>
  );
};
